// A read/control address for an existing answer, never a producer credential.
// Used by both the server's response header and the existing SDK resume URL.
const validId = (value) => typeof value === 'string' && value.length > 0 && value.length <= 256;

export function answerStreamId({ threadId, answerId }) {
  if (!validId(threadId) || !validId(answerId)) throw new TypeError('Invalid answer address');
  return `answer:${encodeURIComponent(threadId)}:${encodeURIComponent(answerId)}`;
}

export function answerFromStreamId(value) {
  if (typeof value !== 'string' || value.length > 1800 || !value.startsWith('answer:')) return null;
  const parts = value.split(':');
  if (parts.length !== 3) return null;
  try {
    const selected = {
      threadId: decodeURIComponent(parts[1]),
      answerId: decodeURIComponent(parts[2]),
    };
    return answerStreamId(selected) === value ? selected : null;
  } catch {
    return null;
  }
}

export function answerReadPath(selected) {
  return `/api/chat/answer/${encodeURIComponent(selected.threadId)}/${encodeURIComponent(selected.answerId)}`;
}
